import React, { useState } from "react";
import SelectPopover from "../../../UI/Form/Select/SelectPopover";
import TextField from "@mui/material/TextField";

export const reportCreationMethodOptions = [
  {
    value: "１冊にまとめる",
    label: "１冊にまとめる",
  },
  {
    value: "検体別に作成する",
    label: "検体別に作成する",
  },
  {
    value: "その他",
    label: "その他",
  },
];

function SelectReportMethod(props) {
  const { requestFormInfo, setRequestFormInfo } = props;
  const [other, setOther] = useState(!reportCreationMethodOptions.some(item => item.value === requestFormInfo?.reportCreationMethod));

  return (
    <>
      <div className="h-[52px]">
        <SelectPopover
          selectedValue={other ? 'その他' : requestFormInfo?.reportCreationMethod}
          setSelectedValue={(newValue) => {
            if (newValue === 'その他') {
              setOther(true);
              setRequestFormInfo({
                ...requestFormInfo,
                reportCreationMethod: '',
              });
            } else {
              setOther(false);
              setRequestFormInfo({
                ...requestFormInfo,
                reportCreationMethod: newValue,
              });
            }
          }}
          options={reportCreationMethodOptions}
        />
      </div>
      {other && (
        <div className="h-[52px]">
          <TextField
            InputProps={{
              style: {
                borderRadius: "10px",
                height: "100%",
              },
            }}
            value={requestFormInfo?.reportCreationMethod}
            onChange={(newValue) => {
              setRequestFormInfo({
                ...requestFormInfo,
                reportCreationMethod: newValue.target.value,
              });
            }}
            size="small"
            className="w-full h-full"
          />
        </div>
      )}
    </>
  );
}

export default SelectReportMethod;
